import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { Order } from "../../Domain/Model/Order";
import { Orders } from "../../Domain/Model/Orders";

import { OrderRepository } from "../../Domain/Repository/OrderRepository";
import ProductDataSource from "../DataSource/OrderDataSource";

export class OrderRepositoryImpl implements OrderRepository {
  dataSource: ProductDataSource;

  constructor(_datasource: ProductDataSource) {
    this.dataSource = _datasource;
  }
  getOrders(
    page: number, 
    pageSize: number, 
    orderCode: string, 
    sortOrder: string, 
    orderStatus: any, 
    PaymentMethod: any, 
    DeliveryMethod: any, 
    fromDate: string, 
    toDate: string, 
    sortColumn: string
  ): Promise<PaginationResult<Orders>> {
    return this.dataSource.getOrders(page, pageSize, orderCode, sortOrder, orderStatus, PaymentMethod, DeliveryMethod, fromDate, toDate, sortColumn);
  }
  getOrderById(orderId: number): Promise<Order | null> {
    return this.dataSource.getOrderById(orderId);
  }

  updateOrderStatus(data: any): Promise<boolean>{
    return this.dataSource.updateOrderStatus(data);
  }

  updateDeliveryDate(data: any): Promise<boolean>{
    return this.dataSource.updateDeliveryDate(data);
  }

  addingInvoice(data: any): Promise<boolean>{
    return this.dataSource.addingInvoice(data);
  }
  getOrderTicketById(id: number): Promise<any>{
    return this.dataSource.getOrderTicketById(id);
  }
}